export default __webpack_public_path__ + "static/media/search-icon.3f4f883c.svg";